import UISelect from 'UIComponents/input/UISelect';
//@ts-expect-error file not typed
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import { EMAIL_SUBSCRIPTION } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { INPUT_WIDTHS } from '../../constants/inlineLayout';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useEmailSubscriptionFilter } from '../../hooks/useEmailSubscriptionFilter';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorEmailSubscriptionRelatedConditionsGroup from './EditorEmailSubscriptionRelatedConditionsGroup';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorEmailSubscriptionRelatedConditionsGroupResponsive = props => {
  const {
    condition,
    conditionPath
  } = props;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(EMAIL_SUBSCRIPTION, conditionPath, condition);
  const {
    statusCondition
  } = useEmailSubscriptionFilter(condition);
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition: statusCondition,
    filterFamily: EMAIL_SUBSCRIPTION,
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: onFieldConditionValueChange
  });
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorEmailSubscriptionRelatedConditionsGroup, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      condition: condition,
      onConditionDelete: () => onConditionDelete(conditionPath),
      wrap: false,
      hideChangeFieldButton: true,
      isFilterBranch: true,
      filterFamily: EMAIL_SUBSCRIPTION,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          width: INPUT_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: disableOperatorSelection,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: condition.constructor.toString()
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          minWidth: INPUT_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: condition,
          disabled: disableValueInput,
          filterFamily: EMAIL_SUBSCRIPTION,
          onChange: onFieldConditionValueChange,
          size: "md"
        })
      })]
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
};
export default EditorEmailSubscriptionRelatedConditionsGroupResponsive;